import { createMiddleware } from "@tanstack/react-start";

/**
 * Client middleware that attaches a Supabase bearer token to server function calls.
 * Dynamically imports the Supabase client so the marketing pages do not pay for
 * @supabase/supabase-js on first load (only contact/newsletter RPCs need it).
 */
export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    const { supabase } = await import("./client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
